import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getTableConfig } from './config';
import {
  Actions,
  AppArea,
  NotificationPayload,
  Subjects,
} from 'src/graphql/generated/graphql';
import { DocumentNode } from 'graphql';
import { useAuthContext } from 'src/context/auth.context';
import { useCan } from 'src/utils/can';

type NotificationsTableProps = Omit<TableProps, 'columns'> & {
  data: Partial<NotificationPayload>[];
  refetchDocuments: DocumentNode[];
  className?: string;
};

export const NotificationsTable = ({
  data,
  className,
  refetchDocuments,
  ...props
}: NotificationsTableProps) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { can } = useCan();
  const hasNotificationWritePermission = can({
    appArea: AppArea.Common,
    subject: Subjects.Notifications,
    action: Actions.Write,
  });

  const tableConfig = getTableConfig({
    t,
    data,
    refetchDocuments,
    currentUser: user,
    hasNotificationWritePermission,
  });

  return (
    <div className={className}>
      <Table {...props} data={data} columns={tableConfig} />
    </div>
  );
};
